/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * @export
 */
export const UpdateSortContactSettingRequestContactSettingsInnerStatusEnum = {
    Active: 'active',
    Required: 'required',
    Inactive: 'inactive'
};
export function UpdateSortContactSettingRequestContactSettingsInnerFromJSON(json) {
    return UpdateSortContactSettingRequestContactSettingsInnerFromJSONTyped(json, false);
}
export function UpdateSortContactSettingRequestContactSettingsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        sort: !exists(json, 'sort') ? undefined : json['sort'],
        status: !exists(json, 'status') ? undefined : json['status']
    };
}
export function UpdateSortContactSettingRequestContactSettingsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        sort: value.sort,
        status: value.status
    };
}
